import { useEffect, useState } from 'react'

function getBannerHeight(isVisible: boolean) {
  if (!isVisible) {
    return 0
  }

  const banner = document.querySelector('[data-component="MobileBannerBottom"]')

  return banner instanceof HTMLElement ? banner.offsetHeight : 0
}

export const useBannerHeight = (isVisible: boolean) => {
  const [bannerHeight, setBannerHeight] = useState(0)

  useEffect(() => {
    setBannerHeight(getBannerHeight(isVisible))
  }, [isVisible])

  return bannerHeight
}

export const getPositionClasses = (
  isPromoActive: boolean,
  isVisible: boolean
) => {
  if (!isPromoActive) {
    return 'bottom-4'
  }
  return isVisible ? 'bottom-4' : 'bottom-20'
}
